import gql from 'graphql-tag';

type OccupationMetadata = {
  occupationId: string;
  occupationName: string;
};

export type OccupationMetadataQueryData = {
  occupations: OccupationMetadata[];
};

const OccupationMetadataQuery = gql`
  query OccupationMetadataQuery {
    occupations(input: {})
      @rest(type: "OccupationMetadata", path: "roleSkillProfiles.v1/?action=getOccupations", method: "POST") {
      occupationId
      occupationName
    }
  }
`;

export default OccupationMetadataQuery;
